import React, { useState, useEffect } from 'react';
import {
  Grid, Box, Typography, TextField, Paper, FormControl, InputLabel, Select, MenuItem, Button, Alert, Dialog, DialogTitle, DialogContent
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import eBrary_Logo from '../assets/Logoa.png';
import axios from '../axiosInstance';

const SignupPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    role: 'Student' // default role
  });

  const [error, setError] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [emailForOTP, setEmailForOTP] = useState('');
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const { username, email, password } = formData;
    if (!username || !email || !password) {
      setError("Please fill all required fields.");
      return;
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      toast.info("Creating account and sending OTP to your email...");
      await axios.post('https://backend.scholarkart.in/api/signup', {
        ...formData,
        createdAt: new Date().toISOString(),
      });

      toast.success("OTP sent! Please check your email.");
      setOtpSent(true);
      setEmailForOTP(email);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.msg || 'Signup failed');
    }
  };

  const handleVerifyOTP = async () => {
    setOtpError(null);
    try {
      const res = await axios.post('https://backend.scholarkart.in/api/verify-otp', {
        email: emailForOTP,
        otp
      });

      localStorage.setItem('token', res.data.token);
      localStorage.setItem('loginTime', new Date().toISOString());
      navigate('/mycourse');
    } catch (err) {
      console.error(err);
      setOtpError("Invalid or expired OTP");
    }
  };

  const [timer, setTimer] = useState(600); // 10 mins in seconds

useEffect(() => {
  const countdown = setInterval(() => {
    setTimer((prev) => {
      if (prev <= 1) {
        clearInterval(countdown);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
  return () => clearInterval(countdown);
}, []);



  return (
      <Grid
        container
        sx={{
          height: '100vh',
          width: '100vw',
        }}
      >
      {/* Left Panel */}
        <Grid 
          item 
          sx={{
            width: {
              xs: '100%',  // 100% on mobile (xs = 0px and up)
              md: '50%',   // 50% on desktop (md = 900px and up)
            }
          }} 
          component={Paper} 
          elevation={6} 
          square
        >
          <Box
            sx={{
              mx: 8,
              my: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
                <Link to="/">
                  <img src={eBrary_Logo} alt="eBrary Logo" style={{ height: 60 }} />
                </Link>
        
                <Typography
                    component="h1"
                    variant="h5"
                    sx={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      textShadow: '1px 1px 3px rgba(0, 0, 0, 0.3)',
                    }}
                  >
                    Transformation of eLearning Experience.
                  </Typography>
                  </Box>
                  <Box
                    sx={{
                      mx: 8,
                      my: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
          <Typography variant="h5" fontWeight="bold">Create Your Account</Typography>
          {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1, width: '100%' }}>
            <TextField
              label="Username"
              name="username"
              fullWidth
              margin="normal"
              required
              value={formData.username}
              onChange={handleChange}
            />
            <TextField
              label="Password"
              name="password"
              type="password"
              fullWidth
              margin="normal"
              required
              value={formData.password}
              onChange={handleChange}
            />
            <TextField
              label="Email"
              name="email"
              fullWidth
              margin="normal"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <FormControl fullWidth margin="normal" required>
              <InputLabel id="role-label">Role</InputLabel>
              <Select
                  labelId="role-label"
                  value={formData.role}
                  onChange={(e) => setFormData(prev => ({ ...prev, role: e.target.value }))}
                  label="Role"
                >
                <MenuItem value="Student">Student</MenuItem>
                <MenuItem value="Faculty">Faculty</MenuItem>
                <MenuItem value="Librarian">Librarian</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, background: 'linear-gradient(to right, rgb(7, 67, 197), rgb(11, 2, 114))' }}
            >
              Sign Up
            </Button>
                        <Box textAlign="center" mt={2}>
                          <Typography variant="body2">
                            Already a Member?
                            <Button
                              variant="outlined"
                              size="small"
                              onClick={() => navigate('/LoginPage')}
                              sx={{
                                ml: 1,
                                borderColor: 'rgb(11, 2, 114)',
                                color: 'rgb(11, 2, 114)',
                                fontWeight: 'bold'
                              }}
                            >
                              Sign In
                            </Button>
                          </Typography>
                        </Box>
          </Box>
        </Box>
      </Grid>

      {/* Right Panel */}
    <Grid
      item
      sx={{
        width: '50%',
        background: 'linear-gradient(to right,rgb(11, 2, 114),rgb(7, 67, 197))',
        color: '#fff',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        px: 6,
        display: { xs: 'none', md: 'flex' }
      }}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Your education, your way. Access courses, anytime, anywhere.
      </Typography>
      <Typography variant="body1">
        Welcome to Sva Learn - the ultimate destination for seamless learning and exploration! Access Lesson Notes, Takeaways, Flash Cards, Mind Maps, Quizzes and AI Chatbot.
      </Typography>
    </Grid>

      {/* OTP Modal */}
      <Dialog open={otpSent} maxWidth="xs" fullWidth>
        <DialogTitle>Enter OTP sent to your email</DialogTitle>
        <DialogContent>
          <TextField
            label="OTP"
            fullWidth
            margin="normal"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          {otpError && <Alert severity="error">{otpError}</Alert>}
          <Button
            variant="contained"
            fullWidth
            onClick={handleVerifyOTP}
            sx={{ mt: 2, background: 'linear-gradient(to right, rgb(7, 67, 197), rgb(11, 2, 114))' }}
          >
            Verify OTP
          </Button>
          <Button
            variant="text"
            onClick={async () => {
              await axios.post('https://backend.scholarkart.in/api/resend-otp', { email: emailForOTP });
              alert("OTP resent to your email");
              setOtp('');
              setTimer(600); // reset timer to 10 min
            }}
          >
            Resend OTP
          </Button>
          <Typography variant="body2" sx={{ mt: 1, color: 'gray' }}>
            OTP expires in: {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}
          </Typography>

        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default SignupPage;
